var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useContext } from 'react';
import { useLoad } from '../../Table/hooks/useLoad';
import { SortContext } from '../../Table/utils/Sort/SortContext';
import { StyledTableBodyCell, TableCellContent } from './styled';
export function TableBodyCell(props) {
    const { children, stickyColumn, maxWidth, removeExtraPadding = false } = props, rest = __rest(props, ["children", "stickyColumn", "maxWidth", "removeExtraPadding"]);
    const { hideColRows } = useContext(SortContext) || {};
    const { loading, initialLoading } = useLoad();
    const subsequentLoading = loading && !initialLoading;
    const headers = rest.headers.split(' ');
    const hide = Boolean(hideColRows === null || hideColRows === void 0 ? void 0 : hideColRows.find((colRow) => headers.some((head) => colRow === head)));
    return (<StyledTableBodyCell data-sticky-column={stickyColumn} $stickyColumn={stickyColumn} $hide={hide} $maxWidth={maxWidth} $loading={initialLoading} {...rest}>
      <TableCellContent $removeExtraPadding={removeExtraPadding} $initialLoading={initialLoading} $subsequentLoading={subsequentLoading}>
        {children}
      </TableCellContent>
    </StyledTableBodyCell>);
}
